import { ResolveFn } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { inject, signal } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ProfiliInterface } from '../models/interfaces/profili.interface';
import { environment } from '../../environments/environment';
import { ProfileStore } from '../store/profili.store';
import { SpinnerService } from '../services/spinner-service';



export const profiliResolver: ResolveFn<ProfiliInterface | null> = (route, state) => {
  const spinnerService = inject(SpinnerService);
  spinnerService.enableSpinner();
  
  const httpClient = inject(HttpClient);
  const profiliStore = inject(ProfileStore);
  const url = `/${environment.CONTEXT_AUTORIZZAZIONI}/user/profili`;
  const baseUrl = signal<string>(`${environment.ENV !== 'local' ? environment.BASE_URL : ''}`);
  
  
  if (profiliStore.loaded() || !!profiliStore.resProfiloCompleta()?.data) {
    // * DEBUG
    // console.log(['PROFILI RESOLVER - data already in store, skipping HTTP call'], profiliStore.resProfiloCompleta());
    // console.log(['skipping HTTP call PROFILI']);
    spinnerService.disableSpinner();
    return profiliStore.resProfiloCompleta() ? of(profiliStore.resProfiloCompleta()) : null;
    
  } else {
    
    return httpClient.get<ProfiliInterface>(`${baseUrl()}${url}`, { withCredentials: true })
    .pipe(
      tap((res) => {
        if (res) {
          profiliStore.saveUtenzaCompleta(res);
          spinnerService.disableSpinner();
          }
        }), catchError((error) => {
          console.error('[profiliResolver] Error fetching profili:', error);
          throw error;
        })
      );

  }

};
